export default __webpack_public_path__ + "static/breakpoint-setting-do-light-a707a7621000d1c17c917346fb4fbabc.png";